window.initializePooling = function () {
  // Starts pooling for script when 'data-pooling-script-url' found.
  // When 'data-pooling-refresh-url' found, refreshes page.
  var pool = function () {
    if (typeof poolingTimeout !== "undefined" && poolingTimeout !== null) {
      $.each(poolingTimeout, function (index, timeout) {
        if (timeout != null) {
          clearTimeout(timeout);
        }
      });
    }
    window.poolingTimeout = [];
    $.each(
      $("[data-pooling-script-url], [data-pooling-refresh-url]"),
      (index, elem) =>
        (window.poolingTimeout[index] = setTimeout(
          () =>
            (window.poolingTimeout[index] = setTimeout(function () {
              let refreshUrl, scriptUrl;
              if ((scriptUrl = elem.getAttribute("data-pooling-script-url"))) {
                $.ajax({
                  url: scriptUrl,
                  dataType: "script",
                  complete: pool,
                });
              } else if (
                (refreshUrl = elem.getAttribute("data-pooling-refresh-url"))
              ) {
                window.reloadPage(refreshUrl);
              }
            }, 3000))
        ))
    );
  };
  pool();
  $(document).off("page:change.pooling").on("page:change.pooling", pool);
};
